<template>
  <bs-modal
    ref="modal"
    :need-footer="false"
    :centered="true"
    :large="false"
  >
    <span slot="title">Créer un nouveau ticket pour le service TLS</span>

    <div slot="body">
      <form @submit="submitForm">
        <div class="form-group">
          <label for="caseSubject">Titre</label>
          <input
            id="caseSubject"
            v-model="title"
            type="text"
            class="form-control"
            placeholder="Titre du ticket"
            required
          >
        </div>

        <div class="form-group">
          <label for="caseBody">Message</label>
          <textarea
            id="caseBody"
            v-model="message"
            class="form-control"
            rows="5"
            placeholder="Contenu du message"
            required
          />
        </div>

        <small
          id="passwordHelpBlock"
          class="form-text text-muted"
        >
          Ajouter un message a destination du service TLS. <br>
        </small>

        <div class="form-group text-right mt-4 mb-0">
          <button
            type="submit"
            class="btn btn-primary"
          >
            Transférer
          </button>
        </div>
      </form>
    </div>
  </bs-modal>
</template>

<script>
import ServiceTls from "@/services/ServiceTls";
import BsModal from "@/components/BsModal";
import { toastMessage } from "@/services/utils";

const data = function () {
	return {
		message: null,
		title: null,
	};
};

const openModal = function () {
	this.$refs.modal.openModal();
};

const closeModal = function () {
	this.$refs.modal.closeModal();
};

const submitForm = function(e) {
	e.preventDefault();

	const { title, message, group: { id:groupId } } = this;

	ServiceTls.Cases.create({ message, title, groupId }).then(_ => {
		toastMessage("Requête transférer à ClicRDV !");

		this.message = null;

		closeModal.bind(this)();
	});
};

export default {
	name: "NewCase",
	components: {
		BsModal
	},
	props: {
		tlsCase: {
			type: Object,
			required: true
		},
		group: {
			type: Object,
			required: true
		},
	},
	data,
	watch: {
		"tlsCase": function() {
			this.title = this.tlsCase.subject;
		}
	},
	mounted() {
		this.title = this.tlsCase.subject;
	},
	methods: {
		openModal,
		submitForm
	}
};
</script>